export const createPhoneMask = (phone) => {
    let ret = "";
    if ((typeof phone !== 'undefined' && phone !== null) && phone?.length > 0) {
        let tmp = phone.replace(/\D/g, '');
        ret = `${tmp.toString().slice(0,3)}-${tmp.toString().slice(3,6)}-${tmp.toString().slice(6,10)}`;
    }
    return ret;
}